import React from 'react';

const SuperAdminProject = () => {
    return (
        <div className="projects-container" style={{ fontFamily: "Arial, sans-serif" }}>
            {/* Guide to Creating a Project */}
            <div className="create-project-section">
                <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                How the Project is added to employees?
                </h3>
                <ul style={{ fontSize: "16px", lineHeight: "1.7", color: "#000000", fontWeight: "500" }}>
                    <li>
                        <strong>Step-1: Navigate to the Projects Section</strong>
                        <p>
                            Open the "Sheets" module and select the "Projects" section from the left-hand menu. 
                            This section contains a list of all existing projects along with the option to create new ones.
                        </p>
                        <img src="path-to-step1-image.png" alt="Navigate to Projects" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-2: Click on the "Add" Button</strong>
                        <p>
                            In the Projects section, click the "Add" button at the top-right corner to create a new project.
                            A form will appear where you need to enter essential details.
                        </p>
                        <img src="path-to-step2-image.png" alt="Click Add Button" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-3: Fill in the Basic Project Details</strong>
                        <p>
                            Enter the "Project Name", select the "Pay Type", and choose an "Employee Name" from the dropdown.
                            Once the employee is selected, the system will auto-fill their details such as email and phone number.
                        </p>
                        <img src="path-to-step3-image.png" alt="Fill Project Details" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-4: Select the Client and End Client</strong>
                        <p>
                            Choose the "Client" for the project. The system will automatically fetch and display the "End Client"
                            based on the client selection.
                        </p>
                        <img src="path-to-step4-image.png" alt="Select Client" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-5: Assign an Approval Manager</strong>
                        <p>
                            Click on the "Approval Manager" field and select the person responsible for managing the project.
                            This manager will have access to oversee project activities and approvals.
                        </p>
                        <img src="path-to-step5-image.png" alt="Assign Approval Manager" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-6: Set the Project Duration</strong>
                        <p>
                            Select the "Start Date" of the project. If the project has already begun, you can enter a previous date.
                            Then, set the "End Date" for the project. The end date remains editable in case the project is extended.
                        </p>
                        <img src="path-to-step6-image.png" alt="Set Project Duration" className="step-image" />
                    </li>

                    <li>
                        <strong>Step-7: Confirm and Save the Project</strong>
                        <p>
                            Review all entered details, ensuring everything is correct. Once satisfied, click on the "Save" button
                            to successfully create the project.
                        </p>
                        <img src="path-to-step7-image.png" alt="Confirm and Save" className="step-image" />
                    </li>
                </ul>

                <p className="description" style={{ fontWeight: "500" }}>
                    <strong>Notes:</strong>
                    <ul>
                        <li>If the project can be started, you can give a previous date, but once a project is saved, the start date cannot be edited.
                            The end date remains editable.</li>
                        <li>If the project end date needs to be changed, it can be updated for long-term, unknown, or status updates.</li>
                    </ul>
                </p>
            </div>
        </div>
    );
};

export default SuperAdminProject;
